import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

class RecentUserCard extends React.Component {

  selectUser = () => this.props.onSelectUser(this.props.user.id);

  render() {

    const { classes, username } = this.props;

    return (
      <Card className={classes.gsRecentCard}>
        <CardHeader
          data-test={username}
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader
          }}
          avatar={<Avatar className={classes.recentAvatar}>
            <PersonIcon style={{ color: '#FF6F00' }} />
          </Avatar>}
          title={
            <div variant="body2" style={{ color: '#FF6F00' }}>{username}</div>
          }
        />
      </Card>
    );
  }
}

RecentUserCard.propTypes = {
  classes: PropTypes.object,
  username: PropTypes.string.isRequired
}

export default withStyles(styles)(RecentUserCard);